import { Injectable } from '@angular/core';
import { InputTypeBuilder } from '../input/input-type.builder';
import { FormInputConfig } from '../../interfaces/form-input-config';
import { DropdownInputConfiguration } from '../../models/dropdown-input-configuration.model';
import { InputType } from '@capturum/builders/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Injectable({ providedIn: 'root' })
export class DropdownInputTypeBuilder extends InputTypeBuilder implements FormInputConfig<DropdownInputConfiguration> {
  protected inputType: string = InputType.dropdown;

  protected appendOptions(input: FormlyFieldConfig, configuration: DropdownInputConfiguration): void {
    input.props.virtualScroll = configuration.options.virtualScroll;
    input.props.virtualScrollItemSize = configuration.options.virtualScrollItemSize;
    input.props.appendTo = configuration.options?.appendTo ?? null;
    input.props.withIcons = configuration.options.show_option_icon;
    input.props.filterBy = configuration.options.filterBy || null;

    super.appendOptions(input, configuration);
  }
}
